module.exports = __webpack_public_path__ + "img/ico_email.6b2549c8.svg";